import { render } from "./SvgContainer.vue?vue&type=template&id=e8393da8&scoped=true"
const script = {}

import "./SvgContainer.vue?vue&type=style&index=0&id=e8393da8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8393da8"]])

export default __exports__